export const NAV = {
  root: "site-nav",
  logo: "nav-logo",
  linkServices: "nav-link-services",
  linkAbout: "nav-link-about",
  linkGallery: "nav-link-gallery",
  linkContact: "nav-link-contact",
  ctaQuote: "nav-cta-quote",
  ctaCall: "nav-cta-call",
};

export const HERO = {
  root: "hero",
  ctaQuote: "hero-cta-quote",
  ctaServices: "hero-cta-services",
  ctaCall: "hero-cta-call",
};

export const SERVICES = {
  root: "services",
  card: (slug) => `service-card-${slug}`,
};

export const ABOUT = {
  root: "about",
};

export const GALLERY = {
  root: "gallery",
  image: (i) => `gallery-image-${i}`,
};

export const CONTACT = {
  root: "contact",
  call: "contact-call",
  email: "contact-email",
};

export const QUOTE = {
  root: "quote",
  form: "quote-form",
  inputName: "quote-input-name",
  inputEmail: "quote-input-email",
  inputPhone: "quote-input-phone",
  selectService: "quote-select-service",
  selectServiceTrigger: "quote-select-service-trigger",
  selectServiceItem: (slug) => `quote-select-service-item-${slug}`,
  inputMessage: "quote-input-message",
  submit: "quote-submit",
  successMessage: "quote-success",
};

export const FOOTER = {
  root: "footer",
};
